import React, { useEffect, useState } from "react";
// import PropTypes from 'prop-types'
import { VerifyOTPStyled } from "./styled";
import { userService } from "apiServices";
import { Displays, Forms } from "components";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const VerifyOTP = ({
  memberType,
  phoneNumber,
  email,
  onCancel,
  onVerifySuccess,
}) => {
  const { t } = useTranslation(["common"]);

  useEffect(() => {
    _requestOTP();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_dataOTP, _setDataOTP] = useState();

  const _requestOTP = async () => {
    _setIsBgLoading(true);
    let params = {
      phone_number: phoneNumber,
      member_type: memberType,
    };
    let res = await userService.POST_OTP_REQUEST(params);
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      _setDataOTP(res.data);
    } else {
      _setIsBgLoading(false);
      toast.error(t("Code sending failed. Please contact staff.", { ns: "common" }));
      onCancel && onCancel();
    }
  };

  const _handleClickResendOTP = () => {
    _requestOTP();
  };

  const _handleSubmit = async (values) => {
    let params = {
      token: _dataOTP.request_id,
      otp_code: values.code,
    };
    let res = await userService.POST_OTP_VERIFY(params);
    if (res && res.status === 200) {
      onVerifySuccess && onVerifySuccess(res);
    } else {
      toast.error("OTP code invalid");
    }
  };

  return (
    <VerifyOTPStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      <div className="v_otp_title">
        <Forms.VerifyOTPForm
          phoneNumber={phoneNumber}
          email={email}
          onCancel={onCancel}
          onClickResendOTP={_handleClickResendOTP}
          onSubmit={_handleSubmit}
        />
      </div>
    </VerifyOTPStyled>
  );
};

VerifyOTP.propTypes = {};

export default VerifyOTP;
